import { useI18n } from '../i18n';
import { useConsent } from '../lib/consent';
import icLogo from '../assets/insert-coin-logo.gif';

export function Footer() {
  const { t, localePath } = useI18n();
  const { openLegal } = useConsent();
  const fine = t('footer.fine');
  const fineRest = fine.startsWith('© ') ? fine.slice(2) : fine;
  return (
    <footer>
      <div class="container">
        <div class="footer-top">
          <div class="wordmark">
            <b>Beer</b>
            <em>Cup</em>
          </div>
          <p class="tag">
            <em>{t('footer.tag_a')}</em> {t('footer.tag_b')}
          </p>
        </div>

        <div class="footer-bottom">
          <div class="footer-legal">
            <button type="button" class="footer-link" onClick={() => openLegal('privacy')}>
              {t('footer.privacy')}
            </button>
            <span class="footer-sep">·</span>
            <button type="button" class="footer-link" onClick={() => openLegal('terms')}>
              {t('footer.terms')}
            </button>
          </div>

          <a
            class="footer-brand"
            href="https://insert-coin.io"
            target="_blank"
            rel="noopener"
          >
            <span class="footer-by">{t('footer.by')}</span>
            <img src={icLogo} alt="Insert Coin" class="footer-ic-logo" />
          </a>
        </div>

        <p class="fine">
          <a class="fine-copy" href={localePath('/login')} aria-label="Login">©</a> {fineRest}
        </p>
      </div>
    </footer>
  );
}
